import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { Button } from "userful-chronos-common-ui/dist";
import { Checkmark } from "userful-chronos-common-ui/dist/widgets";
import { IConstellationInfo } from "../../../model/CarbonExternalModels";

interface IProps {
    constellations: { [id: string]: IConstellationInfo };
    selectedConstellations: { [id: string]: IConstellationInfo };
    onSelectedconstellationsChange: (constellations: { [id: string]: IConstellationInfo }) => void;
}

type TSelected = "selected" | "unselected" | "indeterminate";

export default function MultiselectConstellations(props: IProps) {
    const allLength: number = Object.keys(props.constellations).length;
    const selectedLength: number = Object.keys(props.selectedConstellations).length;
    const selected: TSelected =
        selectedLength === 0 ? "unselected" : selectedLength === allLength ? "selected" : "indeterminate";

    return (
        <Dropdown>
            <div className="multi-select-container">
                <Checkmark
                    selected={selected}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (selected === "selected" || selected === "indeterminate") {
                            props.onSelectedconstellationsChange({});
                        } else {
                            props.onSelectedconstellationsChange(props.constellations);
                        }
                    }}
                />
                <Dropdown.Toggle as={Button} bsPrefix="mini-button" id="dropdownToggle">
                    <FontAwesomeIcon icon={faChevronDown} />
                </Dropdown.Toggle>
            </div>

            <Dropdown.Menu
                className="multi-action-menu nonselect"
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                <Dropdown.Item
                    className="multi-action-dropdown-item"
                    onClick={() => {
                        props.onSelectedconstellationsChange(props.constellations);
                    }}
                >
                    <div className="textInside">All ({allLength})</div>
                </Dropdown.Item>
                <Dropdown.Item
                    className="multi-action-dropdown-item"
                    onClick={() => {
                        props.onSelectedconstellationsChange({});
                    }}
                >
                    <div className="textInside">None (0)</div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}
